<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';

const { t } = useI18n();
const dialogRef = ref(null);

const section = (title, body, example = '') => ({ title, body, example });

const sections = computed(() => [
  section(
    t('ARROWS_AI.HELP.SECTIONS.OVERVIEW.TITLE'),
    t('ARROWS_AI.HELP.SECTIONS.OVERVIEW.BODY'),
    t('ARROWS_AI.HELP.SECTIONS.OVERVIEW.EXAMPLE')
  ),
  section(
    t('ARROWS_AI.HELP.SECTIONS.INSTRUCTIONS.TITLE'),
    t('ARROWS_AI.HELP.SECTIONS.INSTRUCTIONS.BODY'),
    t('ARROWS_AI.HELP.SECTIONS.INSTRUCTIONS.EXAMPLE')
  ),
  section(
    t('ARROWS_AI.HELP.SECTIONS.FAQS.TITLE'),
    t('ARROWS_AI.HELP.SECTIONS.FAQS.BODY'),
    t('ARROWS_AI.HELP.SECTIONS.FAQS.EXAMPLE')
  ),
  section(
    t('ARROWS_AI.HELP.SECTIONS.DOCUMENTS.TITLE'),
    t('ARROWS_AI.HELP.SECTIONS.DOCUMENTS.BODY'),
    t('ARROWS_AI.HELP.SECTIONS.DOCUMENTS.EXAMPLE')
  ),
  section(
    t('ARROWS_AI.HELP.SECTIONS.RESOURCES.TITLE'),
    t('ARROWS_AI.HELP.SECTIONS.RESOURCES.BODY'),
    t('ARROWS_AI.HELP.SECTIONS.RESOURCES.EXAMPLE')
  ),
  section(
    t('ARROWS_AI.HELP.SECTIONS.SERVICES.TITLE'),
    t('ARROWS_AI.HELP.SECTIONS.SERVICES.BODY'),
    t('ARROWS_AI.HELP.SECTIONS.SERVICES.EXAMPLE')
  ),
  section(
    t('ARROWS_AI.HELP.SECTIONS.TOOLS.TITLE'),
    t('ARROWS_AI.HELP.SECTIONS.TOOLS.BODY'),
    t('ARROWS_AI.HELP.SECTIONS.TOOLS.EXAMPLE')
  ),
  section(
    t('ARROWS_AI.HELP.SECTIONS.ATTACHMENT_URLS.TITLE'),
    t('ARROWS_AI.HELP.SECTIONS.ATTACHMENT_URLS.BODY'),
    t('ARROWS_AI.HELP.SECTIONS.ATTACHMENT_URLS.EXAMPLE')
  ),
  section(
    t('ARROWS_AI.HELP.SECTIONS.CONTACT_INFO.TITLE'),
    t('ARROWS_AI.HELP.SECTIONS.CONTACT_INFO.BODY'),
    t('ARROWS_AI.HELP.SECTIONS.CONTACT_INFO.EXAMPLE')
  ),
  section(
    t('ARROWS_AI.HELP.SECTIONS.ACTIONS.TITLE'),
    t('ARROWS_AI.HELP.SECTIONS.ACTIONS.BODY')
  ),
  section(
    t('ARROWS_AI.HELP.SECTIONS.PLAYGROUND.TITLE'),
    t('ARROWS_AI.HELP.SECTIONS.PLAYGROUND.BODY'),
    t('ARROWS_AI.HELP.SECTIONS.PLAYGROUND.EXAMPLE')
  ),
  section(
    t('ARROWS_AI.HELP.SECTIONS.INBOXES.TITLE'),
    t('ARROWS_AI.HELP.SECTIONS.INBOXES.BODY'),
    t('ARROWS_AI.HELP.SECTIONS.INBOXES.EXAMPLE')
  ),
  section(
    t('ARROWS_AI.HELP.SECTIONS.SETTINGS.TITLE'),
    t('ARROWS_AI.HELP.SECTIONS.SETTINGS.BODY')
  ),
]);

const open = () => dialogRef.value?.open();

defineExpose({ open });
</script>

<template>
  <button
    type="button"
    class="text-sm font-medium text-n-slate-11 underline decoration-n-slate-8 underline-offset-4 transition-colors hover:text-n-slate-12"
    @click="open"
  >
    {{ t('ARROWS_AI.HELP.LINK') }}
  </button>
  <Dialog
    ref="dialogRef"
    type="edit"
    width="2xl"
    overflow-y-auto
    :title="t('ARROWS_AI.HELP.TITLE')"
    :description="t('ARROWS_AI.HELP.INTRO')"
    :show-confirm-button="false"
    :cancel-button-label="t('ARROWS_AI.CANCEL')"
  >
    <div class="flex max-h-[65vh] flex-col gap-3 overflow-y-auto pe-1">
      <article
        v-for="item in sections"
        :key="item.title"
        class="rounded-xl border border-n-weak bg-n-solid-1 px-4 py-3"
      >
        <h3 class="text-sm font-medium text-n-slate-12">
          {{ item.title }}
        </h3>
        <p
          class="mt-2 mb-0 whitespace-pre-line text-sm leading-6 text-n-slate-11"
        >
          {{ item.body }}
        </p>
        <p
          v-if="item.example"
          class="mt-3 mb-0 rounded-lg bg-n-alpha-2 px-3 py-2 text-sm leading-6 text-n-slate-12"
        >
          <span class="font-medium">{{ t('ARROWS_AI.HELP.EXAMPLE') }}</span>
          {{ item.example }}
        </p>
      </article>
    </div>
  </Dialog>
</template>
